import { PALETTE } from './palette';

export const ALERT_COLORS = {
  SUCCESS: '#F0F9F4', // PALETTE.SUCCESS.LIGHTEST removed from palette
  ERROR: PALETTE.DANGER.LIGHTEST,
  NEUTRAL: PALETTE.PRIMARY.LIGHTER,
  WARNING: '#FFFAE9', // PALETTE.WARNING.LIGHTEST removed from palette
} as const;
